
import DaysCurrent from 'app/days/Current'
import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import useDodoneQuery from 'generated/api/dodones/useDodoneQuery'

export default () => {
  const dodoneId = 'current'
  const { isPending, error, data: { dodone } = {} } = useDodoneQuery({ dodoneId })

  if(isPending) return <div className="p-d"> Loading </div>
  if(error) return <div className="text-red-500"> {error} </div>

  return <Navigate to={ `/dodones/${dodone.id}` } replace />;
}
